import { render, staticRenderFns } from "./bill_detail.vue?vue&type=template&id=627cbed2&scoped=true&"
import script from "./bill_detail.vue?vue&type=script&lang=js&"
export * from "./bill_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cbed2",
  null
  
)

export default component.exports